import { RecipientList } from "./friend";

export const ChatScreen = () => {
  return (
    <div className="flex-1 p-[10px] bg-[#ffffff]">
      <RecipientList />
    </div>
  );
};
